export default [
    {
        name: "login",
        path: "/login",
        component: () => import("@/tenants/NLS/views/login/Login"),
        meta: { layout: "Blank", menu: "", title: "NLS Canvas : Sign in", favicon: "favicon-nls.ico" }
    },
    {
        name: "find-ID",
        path: "/findId",
        component: () => import("@/views/login/FindId"),
        meta: { layout: "Blank", menu: "", title: "NLS Canvas : Find Username", favicon: "favicon-nls.ico" }
    },
    {
        name: "find-password",
        path: "/findPwd",
        component: () => import("@/views/login/FindPwd"),
        meta: { layout: "Blank", menu: "", title: "NLS Canvas : Reset Password", favicon: "favicon-nls.ico" }
    },
    {
        name: "join",
        path: "/join",
        component: () => import("@/tenants/NLS/views/login/Join"),
        meta: { layout: "Blank", menu: "", title: "NLS Canvas : Sign up", favicon: "favicon-nls.ico" }
    },
];
